var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33917 5.50596C9.01374 5.8314 8.4861 5.8314 8.16066 5.50596L5.83325 3.17855L5.83325 12.8334C5.83325 13.2936 5.46016 13.6667 4.99992 13.6667C4.53968 13.6667 4.16658 13.2936 4.16658 12.8334L4.16658 3.17855L1.83917 5.50596C1.51374 5.8314 0.986098 5.8314 0.660662 5.50596C0.335225 5.18053 0.335225 4.65289 0.660662 4.32745L4.41066 0.577452C4.7361 0.252015 5.26374 0.252015 5.58917 0.577452L9.33917 4.32745C9.66461 4.65289 9.66461 5.18053 9.33917 5.50596Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpWhite);
export default __webpack_public_path__ + "static/media/up-white.ed3c7eb4.svg";
export { ForwardRef as ReactComponent };